@if (isIndColumn) {
  <ng-container
    *ngTemplateOutlet="columnTemplate; context: { $implicit: indColumn() }"
  ></ng-container>
} @else {
  <div class="d-flex align-items-center p-2 flex-wrap mb-lg-2">
    <span class="text-secondary d-none d-lg-inline"> Results Filtered </span>
    @for (
      col of tableColumns() | misc: "customTableColumsFilterExists";
      track col;
      let first = $first
    ) {
      <div class="d-flex align-items-center p-2">
        <div
          role="button"
          class="py-1 px-2 hover"
          id="appliedSearchFilterId"
          (click)="col ? openAllFilters(completeFilterListTemplate) : null"
        >
          <span class="small text-body">
            {{
              col?.header || col?.name | misc: "formatTableHeader" | titlecase
            }}
          </span>
          <span class="fw-semibold text-white bg-primary p-1 rounded-1">
            @if (col?.searchValue?.start) {
              {{ col?.searchValue?.start | customDate: "d MMM y HH:mm" }} -
              {{ col?.searchValue?.end | customDate: "d MMM y HH:mm" }}
            } @else {
              {{ col?.searchValue }}
            }
          </span>
        </div>
        @if (!col?.permanent) {
          <span (click)="updateParent.emit({ col: col, action: 'removeCol' })">
            <i class="fa-solid fa-xmark text-body"></i>
          </span>
        }
      </div>
    }
  </div>
}

<ng-template
  #completeFilterListTemplate
  let-completeFilterListTemplateRef="dialogRef"
>
  <div class="dialog-box card">
    <div class="d-flex row-gap-2 column-gap-4 flex-wrap p-lg-2">
      @for (
        indColumn of tableColumns();
        track trackByColumn($index, indColumn)
      ) {
        @if (
          indColumn?.dateRangeKey ||
          indColumn?.searchKey ||
          indColumn?.dropdownKey
        ) {
          <dl>
            @if (indColumn?.header) {
              <dt [class.text-danger]="indColumn?.isFilterRequired">
                {{ indColumn?.header }}
                @if (indColumn?.isFilterRequired) {
                  <span>*</span>
                }
              </dt>
            }
            <dd>
              <ng-container
                *ngTemplateOutlet="
                  columnTemplate;
                  context: { $implicit: indColumn }
                "
              ></ng-container>
            </dd>
          </dl>
        }
      }
    </div>
    @if (shouldDisableApplyBtn()) {
      <span class="text-danger small-font text-end mb-2">
        * Required Field(s)
      </span>
    }

    <div class="row row-cols-2">
      <div class="col">
        <button
          (click)="completeFilterListTemplateRef.close()"
          class="btn btn-dark btn-lg w-100"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary w-100 btn-lg"
          [disabled]="shouldDisableApplyBtn()"
          (click)="completeFilterListTemplateRef.close(true)"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #columnTemplate let-indColumn>
  @if (indColumn?.dateRangeKey) {
    <gtapp-datetime-picker
      [dateRange]="{
        start: indColumn?.searchValue?.start || indColumn?.dateRange?.start,
        end: indColumn?.searchValue?.end || indColumn?.dateRange?.end,
      }"
      (onChangeDateTime)="onChangeDateTime($event, indColumn)"
    ></gtapp-datetime-picker>
  }
  @if (indColumn?.searchKey) {
    <ng-container
      *ngTemplateOutlet="searchTemplate; context: { $implicit: indColumn }"
    ></ng-container>
  }

  @if (indColumn?.dropdownKey) {
    @if (indColumn?.multipleSelect) {
      <div class="d-flex row-gap-4 column-gap-5 flex-wrap">
        @for (item of indColumn?.dropDownList(); track item?.id) {
          <div class="d-flex gap-2">
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="indColumn?.selectedItems?.includes(item?.id)"
              (change)="onSelectMultipleSelectOptions(indColumn, item)"
            />
            <div>
              {{ item?.name }}
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="form-floating">
        <select
          class="form-select"
          [(ngModel)]="selectedDropDownItem"
          (change)="onSelectDropDownItem(selectedDropDownItem, indColumn)"
        >
          @for (status of indColumn?.dropDownList(); track status?.id) {
            <option [ngValue]="status" [disabled]="status?.disabled">
              {{ status?.name }}
            </option>
          }
        </select>
        <label>Status</label>
      </div>
    }
  }
</ng-template>

<ng-template #searchTemplate let-indColumn>
  <div class="mb-1">
    @if (indColumn?.searchValue && !isIndColumn) {
      <dd>
        {{ indColumn?.searchValue }}
        <span class="edit-button ms-2" (click)="removeFilter(indColumn)"></span>
      </dd>
    } @else {
      @if (indColumn?.autoComplete) {
        <gtapp-auto-complete
          [data]="autoCompleteSearchResultList"
          placeHolder="Search {{
            indColumn | misc: 'getFilterHeader' | titlecase
          }}"
          [searchKeyword]="
            indColumn?.autoComplete === 'user'
              ? 'full_name'
              : indColumn?.autoComplete === 'site'
                ? 'company_name'
                : ''
          "
          [initialValue]="indColumn?.searchString"
          [itemTemplate]="autoCompleteTemplate"
          [enableSearchCloseOption]="true"
          (inputChanged)="onAutoCompleteInputSearch($event, indColumn)"
          (selected)="onAutoCompleteItemSelect($event, indColumn)"
          (submitted)="onAutoCompleteItemSelect($event, indColumn)"
          (inputFocused)="onAutoCompleteInputSearch('', indColumn)"
        >
        </gtapp-auto-complete>

        <ng-template #autoCompleteTemplate let-item>
          @switch (indColumn?.autoComplete) {
            @case ("user") {
              <div>{{ item?.full_name }}</div>
            }
            @case ("site") {
              <div>
                <div class="fw-medium">
                  {{ item?.company_name }} [{{ item?.company?.company_name }}]
                </div>
                <div class="small-font text-secondary">
                  {{ item?.address?.full_address }}
                </div>
              </div>
            }
          }
        </ng-template>
      } @else {
        <div class="input-group flex-nowrap">
          <input
            type="text"
            [(ngModel)]="indColumn.searchString"
            placeholder="Search"
            class="form-control w-75"
            (blur)="isIndColumn ? null : searchField(indColumn)"
            (keyup.enter)="
              indColumn?.searchString ? searchField(indColumn) : null
            "
          />
          <span
            class="input-group-text"
            (click)="indColumn?.searchString ? searchField(indColumn) : null"
          >
            <i class="fa-solid fa-filter"></i>
          </span>
        </div>
      }
    }
  </div>
</ng-template>
